import { forwardRef, useImperativeHandle } from 'react'

//MUI
import { Button } from '@mui/material'

//hooks
import useDisplayModalHook from 'hooks/useDisplayModalHook'

//images
import questionIcon from 'assets/images/modals/icons/question.svg'

const Question = ({ accept, elementsContent }, ref) => {
    const {
        buttons,
        heading,
        text
    } = elementsContent
    const {
        modal,
        handleModal,
    } = useDisplayModalHook()

    useImperativeHandle(ref, () => ({
        open: () => {
            handleModal()._show()
        },
        close: () => {
            handleModal()._hide()
        }
    }))

    const handleAccept = () => {
        handleModal()._hide()
        accept()
    }

    return (
        <div className={`overlay question ${modal.overlay ? 'show' : ''}`} key={modal.overlay}>
            <div className={`modal ${modal.box ? 'show' : ''}`}>
                <div className="body">
                    <img src={questionIcon} className="main" />
                    <b>
                        {heading || 'Продължаване на действието'}
                    </b>
                    <p>
                        {text || 'Предприетите от Вас действия може да са необратими.'}
                    </p>
                </div>
                <div className="footer">
                    <Button
                        className="secondary"
                        onClick={handleModal()._hide}
                    >
                        {buttons?.cancel || 'Отказ'}
                    </Button>
                    <Button
                        onClick={handleAccept}
                    >
                        {buttons?.accept || 'Продължавам'}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default forwardRef(Question)